module.exports = __webpack_public_path__ + "static/Welding Photo-d20ecbc71a4e749e9f1e8cf5ebbd7465.jpg";